<template>
    <div class="col-12">
      <div class="search-padd">
        <div class="col-12 override-padding">
          <div class="crm_admin_heading admin_heading_8_1 text-align-center"># of Purchases</div>
          <div class="crm_admin_heading admin_heading_4 text-align-center">Total &#36; Ordered</div>
          <div class="crm_admin_heading admin_heading_4 text-align-center">Total &#36; Processed</div>
          <div class="crm_admin_heading admin_heading_8_1 text-align-center"># of CC Orders</div>
          <div class="crm_admin_heading admin_heading_2 text-align-center">Avg. &#36;</div>
        </div>
        <div style="clear: both;"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div class="order_items" v-if="orderItems.length > 0">
          <div class="crm_admin_field_lists admin_heading_8_1 text-align-center">
              {{ totalOrders.noOfPurchase }}
          </div>
          <div class="crm_admin_field_lists admin_heading_4 text-align-center">
              &#36;{{ totalOrders.totalOrderAmount }}
          </div>
          <div class="crm_admin_field_lists admin_heading_4 text-align-center">
            &#36;{{ totalOrders.totalProcessedAmount }}
          </div>
          <div class="crm_admin_field_lists admin_heading_8_1 text-align-center">
            {{ totalOrders.noOfCcOrders }}
          </div>
          <div class="crm_admin_field_lists admin_heading_2 text-align-center">
            &#36;{{ totalOrders.avgAmount }}
          </div>
          <div style="clear: both;"></div>
        </div>
        <div class="col-12 override-padding" v-if="orderItems.length == 0">
          No orders found
        </div>
        <div class="col-12 override-padding mt-4">
          <div class="crm_admin_heading orders_heading_1 text-align-center">Status</div>
          <div class="crm_admin_heading orders_heading_2 text-align-left">Invoice #</div>
          <div class="crm_admin_heading orders_heading_1 text-center"># Months</div>
          <div class="crm_admin_heading orders_heading_2 text-align-left">Unit Type</div>
          <div class="crm_admin_heading orders_heading_1 text-align-center">Quantity</div>
          <div class="crm_admin_heading orders_heading_1 text-align-center">Total Amount</div>
          <div class="crm_admin_heading orders_heading_2 text-align-center">Date</div>
          <div class="crm_admin_heading orders_heading_2 text-align-left">Purchased By</div>
          <div class="crm_admin_heading orders_heading_2 text-align-left">Payment Status</div>
        </div>
        <div style="clear: both;"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div class="purchashed_items" v-if="orderItems.length > 0">
          <div v-for="(item, pindex) in orderItems" class="purchase_items">
            <div class="crm_admin_field_lists orders_heading_1 text-align-center">
              <i :class="getStatusIcon(item.orderStatus)"></i>
            </div>
            <div class="crm_admin_field_lists orders_heading_2 text-align-left">
                <a href="javascript:void(0);" class="invoice_link" @click="getInvoicePdf(item)">{{ item.invoiceNo }}</a>
            </div>
            <div class="crm_admin_field_lists orders_heading_1 text-center text-break">
                {{ item.orderDurationValue }}
            </div>
            <div class="crm_admin_field_lists orders_heading_2 text-align-left text-break">
                {{ item.unitType }}
            </div>
            <div class="crm_admin_field_lists orders_heading_1 text-align-center">
              {{ item.noOfUnits }}
            </div>
            <div class="crm_admin_field_lists orders_heading_1 text-align-center">
              &#36;{{ item.totalAmount }}
            </div>
            <div class="crm_admin_field_lists orders_heading_2 text-align-center">
              {{ item.date }}
            </div>
            <div class="crm_admin_field_lists orders_heading_2 text-align-left text-break">
              {{ item.purchasedBy }}
            </div>
            <div class="crm_admin_field_lists orders_heading_2 text-align-left text-break" v-if="!item.checkReceivedFlag && item.paymentMethod == 'check'">
              <a href="javascript:void(0);" @click="showCheckOrderUpdateModal(item.orderId, item.subscriptionId, item.noOfUnits)">{{ getPaymentStatus(item.checkReceivedFlag, item.paymentMethod) }}</a>
            </div>
            <div class="crm_admin_field_lists orders_heading_2 text-align-left text-break" v-else>
              {{ getPaymentStatus(item.checkReceivedFlag, item.paymentMethod) }} 
            </div>
            <div style="clear: both;"></div>
          </div>
        </div>
        <div class="col-12 override-padding" v-if="orderItems.length == 0">
          No orders found
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
        <CheckReceivedOrderUpdateModal :isModalVisible="isCheckOrderUpdateModal" @close="closeCheckOrderUpdateModal()">
          <div slot="header" class="sub-heading"><h3>Payment Status</h3></div>
          <div slot="body">
            <form v-on:submit.prevent="updatePaymentStatus()">
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Check Received:</label>
              <div class="col-sm-8 check_received_lbl">
                  <input 
                    type="checkbox" 
                    class="billingInput" 
                    name="check_received" 
                    id="check_received" 
                    value="1" 
                    v-model="checkReceived" 
                    v-validate="'required'">
                  <div v-if="verrors.firstByRule('check_received', 'required')" class="margin-bottom-5 validate-warning-msg">Check Received is required</div>
              </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-4 col-form-label">Check Number:</label>
                <div class="col-sm-8">
                  <input 
                    type="text" 
                    class="form-control billingInput" 
                    placeholder="Check Number"
                    v-model="checkNumber" 
                    name="check_number" 
                    v-validate="'required|numeric'">
                  <div v-if="verrors.firstByRule('check_number', 'required')" class="margin-bottom-5 validate-warning-msg">Check Number is required</div>
                  <div v-if="verrors.firstByRule('check_number', 'numeric')" class="margin-bottom-5 validate-warning-msg">Check Number be numeric</div>
                </div>
            </div>
            <button class="btn btn-primary btn-sm orderBtn" type="submit">Confirm</button>
            </form>
          </div>
          <div slot="footer" class="col-3 override-padding">

          </div>
        </CheckReceivedOrderUpdateModal>
      </div>
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import moment from 'moment';
import axios from 'axios';
import CheckReceivedOrderUpdateModal from './check_received_order_update_modal.vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

Vue.filter('formatExpirationDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMMM DD, YYYY')
  }
});

export default {
      props: ['accountId'],
      data() {
        return {
          orderItems: [],
          totalOrders: [],
          loading: false,
          isCheckOrderUpdateModal: false,
          checkReceived: '',
          checkNumber: '',
          updateOrderId: '',
          updateSubscriptionId: '',
          updateQty: '',
          isEnterpriseAccount: false,
        }
      },
      components: {
        CheckReceivedOrderUpdateModal
      },
      methods: {
        getStatusIcon(status) {
          if (status == "SUCCESS") {
            return 'fa fa-check green_tick';
          } else {
            return 'fa fa-location-arrow red_tick';
          }
        },
        getPaymentStatus(isCheckReceivedFlag, paymentMethod) {
          if (paymentMethod == 'check') {
            return (isCheckReceivedFlag) ? 'Check Received' : 'Check Not Received';
          } else {
            return 'CC Purchase';
          }
        },
        getInvoicePdf(item) {
          let pdfEndPoint;
          if(this.isEnterpriseAccount) {
             pdfEndPoint = '/getEnterpriseOrderInvoicePdf';
          }
          else {
             pdfEndPoint = '/getOrderInvoicePdf';
          }
          axios(pdfEndPoint,
            {
              method: 'POST',
              data: {
                  "billing": {
                      "billing_name": item.billingName,
                      "billing_address": item.address,
                      "billing_address2": item.address2,
                      "billing_city": item.city,
                      "billing_country": item.countryCode,
                      "billing_phone": item.phoneNumber,
                      "billing_state": item.stateCode,
                      "billing_zip": item.zipCode,
                      "billing_primary_admin": item.billingPrimaryAdmin
                  },
                  "orderId": item.orderId
              }
            },
          )
          .then(response => {
            window.open(response.data.invoice_filepath, '_blank');
          })
          .catch(error => {
            console.log(error)
          });
        },
        showCheckOrderUpdateModal(orderId, subscriptionId, qty) {
          this.isCheckOrderUpdateModal = true;
          this.verrors.clear();
          this.updateOrderId = orderId;
          this.updateSubscriptionId = subscriptionId;
          this.updateQty = qty;
        },
        closeCheckOrderUpdateModal() {
          this.isCheckOrderUpdateModal = false;
          this.verrors.clear();
          this.updateOrderId = '';
          this.updateSubscriptionId = '';
          this.checkReceived = '';
          this.checkNumber = '';
          this.updateQty = '';
        },
        updatePaymentStatus() {
          this.$validator.validateAll().then((result) => {
             if ((this.verrors.items.length === 0)) {
               axios('/update-order-status/' + this.accountId,
                  {
                    method: 'PATCH',
                    data:
                    {
                      order_id: this.updateOrderId,
                      check_number: this.checkNumber,
                      check_received: this.checkReceived,
                      subscription_id: this.updateSubscriptionId,
                      qty: this.updateQty,
                    },
                  }
                )
              .then((resp) => {
                this.flash({ message: 'Account status has been activated successfully.', variant: 'success' });
                this.navigate();
              })
              .catch(error => {

              });
             }
          })
          .catch(() => {

          });
        },
        navigate(){
          this.$router.push(this.$router.currentRoute.fullPath)
          this.$router.go();
        }
      },
      created: function () {
        this.loading = true;
        this.orderItems = [];
        this.totalOrders = [];
        axios('/account_lookup_orders/' + this.accountId,
          {
            method: 'GET'
              
          },
        )
        .then(response => {
          this.loading = false;
          this.orderItems = response.data.orderItems;
          this.totalOrders = response.data.totalOrders[0];
          this.isEnterpriseAccount = response.data.isEnterprise;
         })
        .catch(error => {
          console.log(error)
        });
      }
    }

</script>
<style scoped>
.admin_heading_2 { width: 20%; }
.admin_heading_4 { width: 23%; }
.admin_heading_8_1 { width: 17%; }
.orders_heading_1 { width: 10%; }
.orders_heading_2 { width: 12%; }
.orders_heading_5 { width: 16%; }
.orders_heading_8 { width: 19%; }
.orders_heading_7 { width: 14%; }
.orders_heading_5_2 { width: 13%; }
.orders_heading_6_2 { width: 14%; }
.orders_heading_7_2 { width: 16%; }
.orders_heading_8_2 { width: 17%; }
.order_items {
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  color: #707070;
}
.purchase_items:nth-child(odd) {
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  background-color: #FFFFFF !important;
  color: #707070;
}
.purchase_items:nth-child(even) {
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  background-color: #e9e9e9 !important;
  color: #707070;
}
.order_items .crm_admin_field_lists { padding: 10px; }
.green_tick { color: #479a4b; }
.red_tick { color: red; transform: rotate(45deg); }
.invoice_link { color: #00ACEE; }
.orderBtn {
    color: #FFF;
    background-color: #00acee;
    border: 1px solid #00acee;
    padding: 8px !important;
    font-size: 13px;
    font-weight: 900;
}
.col-form-label {
  font-size: 13px !important;
  font-weight: 900;
}
.check_received_lbl {
  padding: 5px 15px;
  margin: 2px 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/account_lookup_orders_tab.vue